"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("@repo/utils");
exports.Heading = (0, react_1.forwardRef)(({ level = "h1", title, className, children, id, ...rest }, ref) => {
    const slug = id ?? (title ? (0, utils_1.convertToSlug)(title) : undefined);
    const HeadingTag = level;
    return ((0, jsx_runtime_1.jsx)(HeadingTag, { id: slug, "data-component-id": "C005", className: className, ref: ref, ...rest, children: title ?? children }));
});
exports.Heading.displayName = "Heading";
